export default __webpack_public_path__ + "static/media/budget.cbcde3f6.svg";